/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Keyword, ContentEditableDirective } from "../../../directives/content-editable.directive";
import { ActionInstance } from "../../../models/action-instance";
import { InstanceData } from "../../../models/instance-data";
import { Event } from "../../../models/event";
import { KeywordService } from "../../../services/keyword.service";
import {Component, Input, OnInit, ViewChild} from "@angular/core";

declare var $: any;

const PROP_SUBJECT = 'subject';
const PROP_BODY = 'body';
const PROP_TO_EMAIL = 'to';
const PROP_TO_USER = 'to_user';
const PROP_TO_GROUP = 'to_group';

@Component({
  selector: 'app-email-action-editor',
  templateUrl: './email-action-editor.component.html'
})
export class EmailActionEditorComponent implements OnInit {
  
  mProperty_ToEmail = PROP_TO_EMAIL;
  mProperty_ToUser = PROP_TO_USER;
  mProperty_ToGroup = PROP_TO_GROUP;
  
  @Input()
  mAction: ActionInstance;
  
  @Input()
  mUniqueIndex: number;

  @Input()
  set event(event: Event) {
    console.log("SMS Editor - Set Event - Old Event: '" + this.mEvent + "', New Event: '" + event + "'");
    this.mEvent = event;
    this.mAvailableKeywords = this.mKeywordService.getAvailableKeywordsForEvent(this.mEvent);
  }

  mEvent: Event;

  @ViewChild(ContentEditableDirective)
  mBodyContent: ContentEditableDirective;
  
  mSubjectData: InstanceData;
  mBodyData: InstanceData;
  
  mAvailableKeywords: Keyword[];
  
  
  constructor(
    private mKeywordService: KeywordService
  ) {}
  
  
  ngOnInit(): void {
    console.log("onInit() - Action: " + (this.mAction == null? "*NULL*" : this.mAction.action == null? "*NULL-ACTION*" : (this.mAction.action.id + "/" + this.mAction.action.name)));
  
    //Get the Subject/Body Data so that it modeled/referenced by the UI
    this.mSubjectData = this.mAction == null || this.mAction.data == null? null : this.mAction.data.find(d => d.property.property == PROP_SUBJECT);
    if (this.mSubjectData == null) {
      this.mSubjectData = new InstanceData();
      this.mSubjectData.property = this.mAction.action.properties.find(p => p.property == PROP_SUBJECT);
      this.mAction.data == null? this.mAction.data = [ this.mSubjectData ] : this.mAction.data.push(this.mSubjectData);
    }
    
    this.mBodyData = this.mAction == null || this.mAction.data == null? null : this.mAction.data.find(d => d.property.property == PROP_BODY);
    if (this.mBodyData == null) {
      this.mBodyData = new InstanceData();
      this.mBodyData.property = this.mAction.action.properties.find(p => p.property == PROP_BODY);
      this.mAction.data == null? this.mAction.data = [ this.mBodyData ] : this.mAction.data.push(this.mBodyData);
    }
  }
  
  addDataForProperty(property: string): void {
    console.log(`addDataForProperty(${property})`);
    
    const newData = new InstanceData();
    newData.property = this.mAction.action.properties.find(p => p.property == property);
    this.mAction.data == null? this.mAction.data = [ newData ] : this.mAction.data.push(newData);
  }
  
  removeData(data: InstanceData): void {
    console.log("removeData() - " + data);
    
    const index = this.mAction.data == null? -1 : this.mAction.data.indexOf(data);
    if (index > -1) {
      this.mAction.data.splice(index, 1);
    }
  }

  addKeyword(keyword: Keyword): boolean {
    this.mBodyContent.addKeyword(keyword);
    return false;
  }

}
